module.exports = __webpack_public_path__ + "img/ordenesERG.96102a86.svg";